import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useState } from "react";
import CustomPagination from "../../../../../components/CustomPagination";
import styles from "./style";
import { useNavigate } from "react-router-dom";

const BankList = ({ data, page, setPage, total, cashAccount }) => {
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const navigate = useNavigate();

  // --- helper so markup stays tidy ---
  const handleRowClick = (bank) => {
    navigate("/dashboard/accountTransaction", {
      state: { bankName: bank.bankName, _id: bank._id, bankType: bank.accountType },
      replace: false, // keep history entry; omit or flip to true as you prefer
    });
  };

  return (
    <>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={styles.TableHead}>Account Details</TableCell>
              <TableCell sx={styles.TableHead}>Account Number</TableCell>
              <TableCell sx={styles.TableHead}>IFSC Code</TableCell>
              <TableCell sx={styles.TableHead}>Amount in Bank</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow
              key={cashAccount._id}
              hover
              sx={{ cursor: "pointer" }} // visual affordance
              onClick={() => handleRowClick(cashAccount)}
            >
              <TableCell sx={styles.tableData}>
                {cashAccount?.bankName}
              </TableCell>
              <TableCell sx={styles.tableData}></TableCell>

              <TableCell sx={styles.tableData}></TableCell>
              <TableCell sx={styles.tableData}>
                ${cashAccount?.currentBalance}
              </TableCell>
            </TableRow>
            {data?.map((item) => (
              <TableRow
                key={item._id}
                hover
                sx={{ cursor: "pointer" }} // visual affordance
                onClick={() => handleRowClick(item)}
              >
                <TableCell sx={styles.tableData}>{item?.bankName}</TableCell>
                <TableCell sx={styles.tableData}>
                  {item?.accountNumber}
                </TableCell>

                <TableCell sx={styles.tableData}>{item?.ifsc}</TableCell>
                <TableCell sx={styles.tableData}>
                  ${item?.currentBalance}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <CustomPagination
          pageCount={total}
          totalItems={total}
          page={page}
          setPage={setPage}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
        />
      </TableContainer>
    </>
  );
};
export default BankList;
